import { IntegrationProvider } from '@gripp/shared-logic';
import { useTranslation } from 'react-i18next';
import { Text, View } from 'react-native';
import { INTEGRATION_PROVIDER_NAMES } from '../../activity/integrationAttributionTag';
import { tokens } from '../../crop-circle/tokens';
import { themedStyleSheet } from '../../../themes/themedStyleSheet';

export type IntegrationManagedCounterNoticeProps = {
  provider: IntegrationProvider;
  testID?: string;
};

// Without this the disabled field reads as a bug rather than as a value the
// integration owns.
export const IntegrationManagedCounterNotice = ({
  provider,
  testID,
}: IntegrationManagedCounterNoticeProps) => {
  const { t } = useTranslation();

  return (
    <View style={styles.container} testID={testID}>
      <Text style={[tokens.typography.body.small, styles.label]}>
        {t('routines.counter.user.integrationManaged', {
          provider: INTEGRATION_PROVIDER_NAMES[provider] ?? provider,
        })}
      </Text>
    </View>
  );
};

const styles = themedStyleSheet((role) => ({
  container: {
    marginBottom: 12,
  },
  label: {
    color: role.textSoft,
    lineHeight: 18,
  },
}));
